import { WindowMaximizeIcon, HomeIcon, PencilIcon, SpinnerIcon, TrashIcon } from 'primeng/icons';

export const PrimeNGIcons = [
    WindowMaximizeIcon,
    HomeIcon,
    PencilIcon,
    SpinnerIcon,
    TrashIcon
]